export default __webpack_public_path__ + "static/media/jac_special_deals_card.fd50a5fa.png";